import GeneralTimezoneAndCurrency from './GeneralTimezoneAndCurrency';

export default GeneralTimezoneAndCurrency;
